import * as React from 'react'

interface PagingButtonsProps {
    currentPage: number
    lastPage: number
    goNextPageClick: () => void
    goBackPageClick: () => void
}

export const PagingButtons = ( props: PagingButtonsProps ) => {
    const { currentPage, goNextPageClick, goBackPageClick, lastPage } = props

    if ( currentPage <= 1 ) {
        return (
            <div>
                <button onClick={ goNextPageClick } className='btn btn-default pull-right'>Další stránka</button>
            </div>
        )
    }
    if ( currentPage === lastPage ) {
        return <button onClick={ goBackPageClick } className='btn btn-default pull-left'>Předchozí stránka</button>
    }
    else {
        return (
            <div>
                <button onClick={ goBackPageClick } className='btn btn-default pull-left'>Předchozí stránka</button>
                <button onClick={ goNextPageClick } className='btn btn-default pull-right'>Další stránka</button>
            </div>
        )
    }
}

export const PagingButtonsGrouped = ( props: PagingButtonsProps ) => {
    const { currentPage, goNextPageClick, goBackPageClick, lastPage } = props

    if ( currentPage <= 1 ) {
        return (
            <div className="btn-group pull-right">
                <button onClick={ goNextPageClick } className='btn btn-default'>Další stránka</button>
            </div>
        )
    }
    if ( currentPage === lastPage ) {
        return(
            <div className="btn-group pull-right">
                <button onClick={ goBackPageClick } className='btn btn-default pull-left'>Předchozí stránka</button>
            </div>
        )

    }
    else {
        return (
            <div className="btn-group pull-right">
                <button onClick={ goBackPageClick } className='btn btn-default'>Předchozí stránka</button>
                <button onClick={ goNextPageClick } className='btn btn-default'>Další stránka</button>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/components/PagingButtons.tsx
 **/